import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export interface SegmentSetOpsModalState {
  isOpen: boolean;
  segmentId: number | null;
}

@Injectable({ providedIn: 'root' })
export class SegmentSetOpsModalService {
  private readonly _state = new BehaviorSubject<SegmentSetOpsModalState>({
    isOpen: false,
    segmentId: null,
  });
  readonly state$ = this._state.asObservable();

  private readonly _executed = new Subject<number>();
  readonly executed$ = this._executed.asObservable();

  open(segmentId: number): void {
    this._state.next({ isOpen: true, segmentId });
  }

  close(): void {
    this._state.next({ isOpen: false, segmentId: null });
  }

  notifyExecuted(segmentId: number): void {
    this._executed.next(segmentId);
  }
}
